import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    advantages: {
      anticipate: 'Anticipate your deadlines: URSSAF, accounting...',
      buy: 'Make your first professional expenses right away',
      develop: 'Develop your business with our partners',
    },
    title: 'Your account is ready. Make the most of it!',
  },
  fr: {
    advantages: {
      anticipate: 'Anticipez vos échéances\xa0: URSSAF, comptabilité...',
      buy: 'Réalisez vos premières dépenses pro sans attendre',
      develop: 'Développez votre activité grâce à nos partenaires',
    },
    title: 'Votre compte est prêt, tirez-en le maximum\xa0!',
  },
});

export default locales;
